import React from 'react';

export default function DemoPanel() {
  return (
    <div className="p-6 rounded-xl border" style={{ borderColor: 'var(--color-border)' }}>
      <div className="flex items-center gap-2 mb-1">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: 'var(--color-primary)' }}>
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
          <line x1="16" y1="2" x2="16" y2="6"/>
          <line x1="8" y1="2" x2="8" y2="6"/>
          <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
        <h3 className="font-heading text-lg font-semibold" style={{ color: 'var(--color-primary)' }}>Book a Demo</h3>
      </div>
      <p className="text-sm font-body text-gray-500 mb-5">Schedule a 30-minute walkthrough with our team. We'll tailor the session to your role and requirements.</p>

      {/* Calendar embed placeholder */}
      <div
        className="rounded-lg border-2 border-dashed flex flex-col items-center justify-center py-10 px-4 text-center"
        style={{ borderColor: 'rgba(59,76,76,0.15)', background: 'rgba(59,76,76,0.02)' }}
      >
        <div className="w-10 h-10 rounded-full flex items-center justify-center mb-3" style={{ background: 'rgba(59,76,76,0.08)', color: 'var(--color-primary)' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
        </div>
        <p className="text-sm font-caption font-medium mb-1" style={{ color: 'var(--color-primary)' }}>Calendar scheduling</p>
        <p className="text-xs font-body text-gray-400">Calendly integration coming soon</p>
      </div>

      <div className="mt-4 pt-4 border-t border-gray-100">
        <p className="text-xs font-caption text-gray-400 text-center">Or email us directly at <a href="mailto:demo@seeddrive.com" className="hover:underline" style={{ color: 'var(--color-secondary)' }}>demo@seeddrive.com</a></p>
      </div>
    </div>
  );
}
